import { Component } from '@angular/core';
import { LoginComponent } from '../login/login.component';
import { DialogModule } from 'primeng/dialog';
import { CommonModule, NgClass } from '@angular/common';
import { ConnectService } from '../../../services/connect.service';
import { AbstractSigaleComponent } from '../../abstract-sigale.component';
import { TranslateModule } from '@ngx-translate/core';
import { FileUploadModule } from 'primeng/fileupload';
import { AlertComponent } from '../../alert/alert.component';
import { Credentials } from '../../../models/credentials.model';
import { AuthCoreService } from '../../../services/auth-core.service';
import { isNullOrUndefined } from '../../../utils/functions';

@Component({
	selector: 'sigale-login-modal',
	standalone: true,
	imports: [
		CommonModule,
		LoginComponent,
		DialogModule,
		NgClass,
		AlertComponent,
		TranslateModule,
		FileUploadModule
	],
	templateUrl: './login-modal.component.html',
	styleUrl: './login-modal.component.scss'
})
export class LoginModalComponent extends AbstractSigaleComponent {
	visible = false;
	login: string;
	loginData: Credentials = new Credentials();
	peutModifierLogin: boolean = true;

	constructor(private connectService: ConnectService,
				private authCoreService: AuthCoreService) {
		super();
		this.translateService.setDefaultLang('FR');
		this.translateService.currentLang = 'FR';
	}

	ngOnInit() {
		super.ngOnInit();
		setTimeout(() => {
			// le chargement des langues se fait après un petit délai car dans le cas contraire, on a une erreur js dans la console front "ExpressionChangedAfterItHasBeenCheckedError"
			this.translateService.setTranslation('FR', this.traductionFR(), true);
			this.translateService.setTranslation('IT', this.traductionIT(), true);
		}, 1000);

	}

	/**
	 * Ouvre la modale et déconnecte l'utilisateur connecté.
	 */
	ouvrir(): void {
		this.visible = true;
		this.loginData.login = this.authCoreService.loginUtilisateurConnecte();
		this.loginData.password = '';
		this.peutModifierLogin = isNullOrUndefined(this.authCoreService.loginUtilisateurConnecte());
		this.connectService.logoutSansRedirection();
		this.connectService.supprimerTokenAuthentification();
	}

	/**
	 * Ferme la modale.
	 */
	fermer(): void {
		this.visible = false;
	}

	/**
	 * Callback appelé en cas de connexion réussie.
	 */
	loginSucces(): void {
		this.fermer();
	}

	traductionFR(): any {
		return {
			"SIGALE_ANGULAR": {
				"COMPONENTS": {
					"LOGIN": {
						"CONNEXION": "Connexion",
						"FIELDSET": "Veuillez vous identifier",
						"IDENTIFIANT": "Identifiant",
						"PASSWORD": "Mot de passe"
					},
					"MODAL_LOGIN": {
						"TITRE": "Reconnexion obligatoire"
					}
				}
			}
		};
	}

	traductionIT(): any {
		return {
			"SIGALE_ANGULAR": {
				"COMPONENTS": {
					"LOGIN": {
						"CONNEXION": "IT:Connexion",
						"FIELDSET": "IT:Veuillez vous identifier",
						"IDENTIFIANT": "IT:Identifiant",
						"PASSWORD": "IT:Mot de passe"
					},
					"MODAL_LOGIN": {
						"TITRE": "Riconnessione obbligatoria"
					}
				}
			}
		};
	}
}
